import React from 'react';

import type { ExtensionManifest, ExtensionModule } from '@atlaskit/editor-common/extensions';
import TemplateIcon from '@atlaskit/icon/core/app';

import type { Snippet } from '../services/snippetApi';

import { snippetQuickInsertAction } from './snippetQuickInsertAction';

type CreateSnippetExtensionProps = {
	snippets: Snippet[];
};

export const snippetExtensionManifest = ({
	snippets,
}: CreateSnippetExtensionProps): ExtensionManifest => {
	const quickInsert: ExtensionModule[] = snippets.map((snippet) => ({
		key: `snippet-${snippet.snippetId}`,
		title: snippet.name,
		description: `by ${snippet.createdBy}`,
		icon: async () => () => <TemplateIcon label="Snippet" />,
		action: snippetQuickInsertAction(snippet),
	}));

	return {
		title: 'Snippets',
		description: 'Insert saved snippets into your page',
		type: 'com.atlassian.confluence.macro.core',
		key: 'snippet-extension',
		icons: {
			// eslint-disable-next-line import/dynamic-import-chunkname
			'48': () => import('@atlaskit/icon/core/app'),
		},
		modules: {
			quickInsert,
		},
	};
};
